import { DonorType, OrganType } from '@/api/apis/case';
import { OrganLastCallDays } from '@/api/apis/resources';

export const getCsActualCertificates = (
  shiftCertificates: OrganType[],
  employeeCertificates: OrganType[],
  lastCallDaysByOrgan: OrganLastCallDays,
  lastCallDays?: Record<DonorType, OrganLastCallDays>,
) => {
  return shiftCertificates.map((shiftCert) => {
    const isActive = employeeCertificates.some((empCert) => empCert === shiftCert);
    return {
      organ: shiftCert,
      days: lastCallDaysByOrgan[shiftCert],
      byOrgan: lastCallDays
        ? [
            { donor: DonorType.DCD, days: lastCallDays[DonorType.DCD][shiftCert] },
            { donor: DonorType.DBD, days: lastCallDays[DonorType.DBD][shiftCert] },
          ]
        : [],
      isActive,
    };
  });
};

export const formatDays = (days?: number) => {
  if (days === undefined || days === null) return '-';

  if (days === 0) return '-';

  if (days > 0 && days < 1) return '<1d';

  return `${Math.round(days)}d`;
};
